/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Person from "@material-ui/icons/Person";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
import DropDown from "./DropDown";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";

const useStyles = makeStyles(() => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    height: "76px",
    padding: "0 20px",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    gap: "15px",
  },

  headerItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "120px",
  },

  iconRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    height: "26px",
  },

  itemIcon: {
    fontSize: "22px",
    color: brandTheme.black,
  },

  arrowIcon: {
    fontSize: "18px",
    marginTop: "2px",
    color: brandTheme.black,
  },

  itemText: {
    marginTop: "0px",
    lineHeight: "14px",
    fontSize: "13px",
    color: brandTheme.black,
    textAlign: "center",
    fontWeight: 400,
    textTransform: "capitalize",
  },
}));

const DesktopHeader = ({ props, userDetailsData }) => {
  const classes = useStyles();

  const [openProfile, setOpenProfile] = useState(null);
  const [branchName, setBranchName] = useState("New Delhi");
  const [username, setUserName] = useState("");
  const [moduleData, setModuleData] = useState({});

  const { authToken } = useSelector((state) => state.login.authData);
  const { email } = useSelector((state) => state.login.userData);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    setBranchName(userDetailsData?.branchName);
    setUserName(userDetailsData?.name);

    function storageChange(event) {
      if (event.key === "persist:root") {
        const { login } = JSON.parse(event.newValue);
        const { authData } = JSON.parse(login);

        if (authData && !authData.isAuthenticated) navigateToLoginPage();
      }
    }

    window.addEventListener("storage", storageChange);
    return () => window.removeEventListener("storage", storageChange);
  }, []);

  const navigateToLoginPage = async () => {
    const result = await apiHandler({
      url: endpoint.APP_URL,
      authToken: authToken,
    });

    if (result?.data?.main) {
      window.location.href = result.data.main;
    }
  };

  const openModule = async (module) => {
    const result = await apiHandler({
      url: endpoint.RETAIN_TOKEN,
      method: "POST",
      authToken: authToken,
      data: {
        username: email,
        accessToken: authToken,
      },
    });

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const URL = moduleData[module] + "/auto/" + result?.data?.uuid;
      window.open(URL, "_self");
    }
  };

  const getOtherAppsUrl = async () => {
    const result = await apiHandler({ url: endpoint.APP_URL });
    setModuleData(result.data);
  };

  useEffect(() => {
    if (authToken) getOtherAppsUrl();
  }, [authToken]);

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const handleCloseProfile = () => setOpenProfile(null);

  const formatDate = () => {
    const d = new Date();
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("default", { month: "long" });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Grid container className={classes.headerContainer}>
      <Grid item xs={12} className={classes.rightSection}>
        
        {/* DATE */}
        <div className={classes.headerItem}>
          <div className={classes.iconRow}>
            <CalendarTodayIcon className={classes.itemIcon} />
          </div>
          <span className={classes.itemText}>{formatDate()}</span>
        </div>

        {/* BRANCH */}
        <div className={classes.headerItem}>
          <div className={classes.iconRow}>
            <AccountBalanceIcon className={classes.itemIcon} />
          </div>
          <span className={classes.itemText}>{branchName}</span>
        </div>

        {/* PROFILE */}
        <div className={classes.headerItem} onClick={handleClickProfile}>
          <div className={classes.iconRow}>
            <Person className={classes.itemIcon} />
            {openProfile ? (
              <KeyboardArrowUpIcon className={classes.arrowIcon} />
            ) : (
              <KeyboardArrowDownIcon className={classes.arrowIcon} />
            )}
          </div>

          <span className={classes.itemText}>{username}</span>
        </div>
      </Grid>

      <DropDown
        navigateToLoginPage={navigateToLoginPage}
        handleCloseProfile={handleCloseProfile}
        openProfile={openProfile}
        handleExitToSSO={() => openModule("main")}
      />

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

DesktopHeader.propTypes = {
  classes: PropTypes.object,
};

export default DesktopHeader;
